import ToolTip from "components/design/toolTip";
import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import { FilePlus } from "components/icons/FilePlus";
import { WSeriesFormUpload } from "components/WSeriesFormUpload";
import { WSeriesSelectExistingVendor } from "components/WSeriesSelectExistingVendor";
import { useModal } from "hooks/useModal";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { Merchant } from "types/Models/merchant";

type UploadFormProps = {
  merchant: Merchant;
  taskId: string;
  groupId: string;
  updateMerchant: () => void;
  editable: boolean;
  season: string;
};

export const UploadForm = ({
  merchant,
  taskId,
  groupId,
  updateMerchant,
  editable,
  season,
}: UploadFormProps) => {
  const { isAdmin } = useRoleBasedView();
  const {
    open: openFormUploadModal,
    close: closeFormUploadModal,
    isOpen: showFormUploadModal,
  } = useModal();

  const existingVendorModal = useModal();

  const updateMerchantAndCloseEdit = () => {
    updateMerchant();
  };

  return (
    <>
      <Dropdown.Root>
        <Dropdown.Trigger asChild className="t-group t-select-none">
          <div>
            <ToolTip text="Upload form">
              <button className="all:unset">
                <FilePlus className="t-text-text-30" />
              </button>
            </ToolTip>
          </div>
        </Dropdown.Trigger>
        <Dropdown.Portal>
          <Dropdown.Content align="end">
            <Dropdown.Item
              textValue="Upload file"
              onSelect={openFormUploadModal}
            >
              Upload file
            </Dropdown.Item>
            {isAdmin && (
              <Dropdown.Item
                textValue="Add from existing vendor"
                onSelect={existingVendorModal.open}
              >
                Add from existing vendor
              </Dropdown.Item>
            )}
          </Dropdown.Content>
        </Dropdown.Portal>
      </Dropdown.Root>
      <WSeriesFormUpload
        show={showFormUploadModal}
        closeModal={closeFormUploadModal}
        taskId={taskId}
        groupId={groupId}
        merchant={merchant}
        updateMerchant={updateMerchantAndCloseEdit}
        editable={editable}
        openModal={openFormUploadModal}
        season={season}
      />
      <WSeriesSelectExistingVendor
        isOpen={existingVendorModal.isOpen}
        close={existingVendorModal.close}
        taskId={taskId}
        merchant={merchant}
        groupId={groupId}
        season={season}
      />
    </>
  );
};
